import { Box, Button, Flex, Text } from '@radix-ui/themes';
import React, { useState } from 'react';
import Icon from '~/components/Icon';
import useAuthentication from '~/hooks/use-authentication';

function ChooseOrganization() {
  const { usersOrganizations, changeOrganization } = useAuthentication();
  const [loading, setLoading] = useState(false);

  return (
    <Flex
      align='center'
      direction='column'
      gap='40px'
      p='20px'
    >
      <Text
        size='5'
        weight='bold'
      >
        Choose organization
      </Text>
      <Flex
        direction='column'
        gap='16px'
      >
        {usersOrganizations.map(t => (
          <Box
            width='350px'
            key={t.id}
            asChild
          >
            <Button
              color='gray'
              radius='full'
              variant='outline'
              disabled={loading}
              onClick={() => {
                setLoading(true);
                changeOrganization(t.id);
              }}
            >
              <Box
                width='100%'
                asChild
              >
                <Flex justify='between'>
                  <Text
                    size='2'
                    weight='regular'
                  >
                    {t.name}
                  </Text>
                  <Icon
                    name='arrow-right'
                    inline
                    width={16}
                    height={16}
                    color='var(--neutral-a11)'
                  />
                </Flex>
              </Box>
            </Button>
          </Box>
        ))}
      </Flex>
    </Flex>
  );
}

export default ChooseOrganization;
